export default __webpack_public_path__ + "static/media/euro.e383153b.svg";